import { render, createRoot } from 'react-dom'
import { UserAccreditingAgencies } from "./user-accrediting-agencies";
import { UserDemographicSettings } from "./user-demographic-settings";
import { UserEarnedAccreditations } from "./user-earned-accreditations";

export default function renderShortcodes() {
  window.addEventListener('load', () => {

    const userDemographics = document.querySelectorAll('.tgbl-user-demographic-settings')
    for ( const userDemographic of userDemographics ) {
      const component = <UserDemographicSettings
        userID={userDemographic.dataset.userId}
        professions={JSON.parse(userDemographic.dataset.professions)}
        regions={JSON.parse(userDemographic.dataset.regions)}
        associations={JSON.parse(userDemographic.dataset.associations)}
      />

      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(userDemographic).render(component)
        : render(component, userDemographic)
    }

    const userAgencies = document.querySelectorAll('.tgbl-user-accrediting-agencies')
    for ( const userAgency of userAgencies ) {
      const component = <UserAccreditingAgencies userID={userAgency.dataset.userId}/>

      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(userAgency).render(component)
        : render(component, userAgency)
    }

    const userEarnedAccreds = document.querySelectorAll('.tgbl-user-earned-accreditations-indexed')
    for ( const earnedAccredGroup of userEarnedAccreds ) {
      const component = <UserEarnedAccreditations
        userID={ earnedAccredGroup.dataset.userId }
        contentId={earnedAccredGroup.dataset.contentId}
        layout={earnedAccredGroup.dataset.layout}
        showYearHeadings={ earnedAccredGroup.dataset.showYearHeadings === '1' }
        nothingFoundMessage={ earnedAccredGroup.dataset.stringNothingFound }
      />

      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(earnedAccredGroup).render(component)
        : render(component, earnedAccredGroup)
    }
  })
}
